import React from "react";
import { currentVersion } from "../../utils/AuxFunctions";

const Footer = () => {
  return (
    <footer className="py-2 px-4 bottom-0 bg-transparent relative">
      ODT {new Date().getFullYear()} - Todos los derechos reservados - V-
      {currentVersion}
    </footer>
  );
};

export default Footer;
